import { render, staticRenderFns } from "./ChitPrint.vue?vue&type=template&id=8b89fcbc&scoped=true"
import script from "./ChitPrint.vue?vue&type=script&lang=ts"
export * from "./ChitPrint.vue?vue&type=script&lang=ts"
import style0 from "./ChitPrint.vue?vue&type=style&index=0&id=8b89fcbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b89fcbc",
  null
  
)

export default component.exports